import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '明星八卦', path: '/category/star-gossip', hasDropdown: true },
  { label: '网红翻车', path: '/category/influencer-fails', hasDropdown: true },
  { label: '擦边吃瓜', path: '/category/edgy-content' },
  { label: '爆料大赛', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-secondary-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <span className={`font-heading text-2xl md:text-3xl transition-colors duration-300 ${scrolled ? 'text-primary-500' : 'text-white'}`}>
              吃瓜网
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap group ${
                  location.pathname === item.path
                    ? scrolled ? 'text-primary-500' : 'text-white'
                    : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
                }`}
              >
                {item.label}
                {item.hasDropdown && (
                  <i className="ri-arrow-down-s-line ml-1 text-xs align-middle"></i>
                )}
                <span className={`absolute -bottom-1 left-0 h-0.5 rounded-full transition-all duration-300 ${
                  location.pathname === item.path ? 'w-full bg-primary-500' : 'w-0 bg-primary-500 group-hover:w-full'
                }`}></span>
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/about"
              className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30'
              }`}
            >
              立即爆料 <i className="ri-arrow-right-up-line ml-1"></i>
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-800 hover:bg-secondary-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50/98 backdrop-blur-md border-t border-secondary-200/50 px-4 py-4 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center justify-between px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === item.path
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-700 hover:bg-secondary-100'
              }`}
            >
              {item.label}
              {item.hasDropdown && <i className="ri-arrow-down-s-line"></i>}
            </Link>
          ))}
          <Link
            to="/about"
            className="flex items-center justify-center mt-2 px-4 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            立即爆料 <i className="ri-arrow-right-up-line ml-1"></i>
          </Link>
        </div>
      </div>
    </nav>
  );
}